<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{totalUsersCount}}</h4>
            <p>Total users</p>
          </b-card-body>
          <card-line1-chart-example chartId="card-chart-01" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{chatMessagesCount}}</h4>
            <p>Chat messages sent</p>
          </b-card-body>
          <card-line2-chart-example chartId="card-chart-02" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-warning">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{notificationsSentCount}}</h4>
            <p>Notifications sent</p>
          </b-card-body>
          <card-line3-chart-example chartId="card-chart-03" class="chart-wrapper" style="height:70px;" height="70"/>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-danger">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{trainingAndGamesCreatedCount}}</h4>
            <p>Games and training created</p>
          </b-card-body>
          <card-bar-chart-example chartId="card-chart-04" class="chart-wrapper px-3" style="height:70px;" height="70"/>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{parentsCount}}</h4>
            <p>Parents registered</p>
          </b-card-body>
          <card-line1-chart-example chartId="card-chart-01" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{chatPushCount}}</h4>
            <p>Chat push notifications</p>
          </b-card-body>
          <card-line2-chart-example chartId="card-chart-02" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-warning">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{notificationsSeenCount}}</h4>
            <p>Notifications cleared</p>
          </b-card-body>
          <card-line3-chart-example chartId="card-chart-03" class="chart-wrapper" style="height:70px;" height="70"/>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-danger">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{gamesCreatedCount}}</h4>
            <p>Games created</p>
          </b-card-body>
          <card-bar-chart-example chartId="card-chart-04" class="chart-wrapper px-3" style="height:70px;" height="70"/>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{playersCount}}</h4>
            <p>Players registered</p>
          </b-card-body>
          <card-line1-chart-example chartId="card-chart-01" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{chatPushCount}}</h4>
            <p>Chat push notifications</p>
          </b-card-body>
          <card-line2-chart-example chartId="card-chart-02" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-warning">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{notificationsAbsenceCount}}</h4>
            <p>Absence notifications</p>
          </b-card-body>
          <card-line3-chart-example chartId="card-chart-03" class="chart-wrapper" style="height:70px;" height="70"/>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-danger">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{trainingCreatedCount}}</h4>
            <p>Training created</p>
          </b-card-body>
          <card-bar-chart-example chartId="card-chart-04" class="chart-wrapper px-3" style="height:70px;" height="70"/>
        </b-card>
      </b-col>
    </b-row>
    
  </div>
</template>

<script>
import _ from 'underscore'
import { db } from '@/config/devowqlo';
import CardLine1ChartExample from './dashboard/CardLine1ChartExample'
import CardLine2ChartExample from './dashboard/CardLine2ChartExample'
import CardLine3ChartExample from './dashboard/CardLine3ChartExample'
import CardBarChartExample from './dashboard/CardBarChartExample'
import MainChartExample from './dashboard/MainChartExample'
import SocialBoxChartExample from './dashboard/SocialBoxChartExample'
import CalloutChartExample from './dashboard/CalloutChartExample'
import { Callout } from '@coreui/vue'

export default {
  name: 'dashboard',
  components: {
    Callout,
    CardLine1ChartExample,
    CardLine2ChartExample,
    CardLine3ChartExample,
    CardBarChartExample,
    MainChartExample,
    SocialBoxChartExample,
    CalloutChartExample
  },
  data: function () {
    return {
      totalUsersCount: 0,
      chatMessagesCount: 0,
      notificationsSentCount: 0,
      trainingAndGamesCreatedCount: 0,
      parentsCount: 0,
      chatPushCount: 0,
      notificationsSeenCount: 0,
      notificationsAbsenceCount: 0,
      trainingCreatedCount: 0,
      gamesCreatedCount: 0,
      playersCount: 0,
      playersWithAccess: 0,
      selected: 'Month',
      tableItems: [
        {
          avatar: { url: 'img/avatars/1.jpg', status: 'success' },
          user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'USA', flag: 'us' },
          usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Mastercard', icon: 'fa fa-cc-mastercard' },
          activity: '10 sec ago'
        },
        {
          avatar: { url: 'img/avatars/2.jpg', status: 'danger' },
          user: { name: 'Avram Tarasios', new: false, registered: 'Jan 1, 2015' },
          country: { name: 'Brazil', flag: 'br' },
          usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Visa', icon: 'fa fa-cc-visa' },
          activity: '5 minutes ago'
        },
        {
          avatar: { url: 'img/avatars/3.jpg', status: 'warning' },
          user: { name: 'Quintin Ed', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'India', flag: 'in' },
          usage: { value: 74, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Stripe', icon: 'fa fa-cc-stripe' },
          activity: '1 hour ago'
        },
        {
          avatar: { url: 'img/avatars/4.jpg', status: '' },
          user: { name: 'Enéas Kwadwo', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'France', flag: 'fr' },
          usage: { value: 98, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'PayPal', icon: 'fa fa-paypal' },
          activity: 'Last month'
        },
        {
          avatar: { url: 'img/avatars/5.jpg', status: 'success' },
          user: { name: 'Agapetus Tadeáš', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'Spain', flag: 'es' },
          usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Google Wallet', icon: 'fa fa-google-wallet' },
          activity: 'Last week'
        },
        {
          avatar: { url: 'img/avatars/6.jpg', status: 'danger' },
          user: { name: 'Friderik Dávid', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'Poland', flag: 'pl' },
          usage: { value: 43, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Amex', icon: 'fa fa-cc-amex' },
          activity: 'Last week'
        }
      ],
      tableFields: {
        avatar: {
          label: '<i class="icon-people"></i>',
          class: 'text-center'
        },
        user: {
          label: 'User'
        },
        country: {
          label: 'Country',
          class: 'text-center'
        },
        usage: {
          label: 'Usage'
        },
        payment: {
          label: 'Payment method',
          class: 'text-center'
        },
        activity: {
          label: 'Activity'
        }
      }
    }
  },
  methods: {
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    }
  },
  created(){

    this.totalUsersCount = 0
    this.chatMessagesCount = 0
    this.notificationsSentCount = 0
    this.trainingAndGamesCreatedCount = 0
    this.chatPushCount = 0
      
    var date = new Date("03-03-2019")
    var dateTimestamp = date.getTime()

    var pushDate = new Date("03-10-2019")
    var pushDateTimestamp = pushDate.getTime()
    console.log(date.getTime())

    db.ref('users').child('parents').orderByChild("created").startAt(dateTimestamp).on('value', (parentsSnapshot) =>{

      this.parentsCount += parentsSnapshot.numChildren()
      this.totalUsersCount += this.parentsCount

    })

    db.ref('users').child('players').orderByChild("created").startAt(dateTimestamp).on('value', (playersSnapshot) =>{

      this.playersCount += playersSnapshot.numChildren()
      this.totalUsersCount += this.playersCount


    })


    db.ref('chatMessages').on('value', (chatsSnapshot) =>{

      chatsSnapshot.forEach(chatSnapshot => {

        /*console.log(_.toArray(chatSnapshot.val()))

        _.each(_.toArray(chatSnapshot.val()), (item) => {
          console.log(item)
          if(item.timestamp > dateTimestamp){
            this.chatMessagesCount++
          }
        })*/

        chatSnapshot.forEach(messageSnapshot => {
          if(messageSnapshot.val().timestamp > dateTimestamp && messageSnapshot.val().content.length > 3){
            this.chatMessagesCount++
          }
        })
        

      })

    })

    db.ref('userNotifications').on('value', (userSnapshots) =>{

      userSnapshots.forEach(notificationsSnapshot => {
        /*console.log(_.toArray(chatSnapshot.val()))

        _.each(_.toArray(chatSnapshot.val()), (item) => {
          console.log(item)
          if(item.timestamp > dateTimestamp){
            this.chatMessagesCount++
          }
        })*/

        notificationsSnapshot.child('notifications').forEach(notificationSnapshot => {

          if(notificationSnapshot.val().timestamp > dateTimestamp){
            this.notificationsSentCount++
          }
        })
        

      })
    })

    db.ref('teamTrainings').on('value', (teamsSnapshot) =>{

      teamsSnapshot.forEach(trainingsSnapshot => {
        /*console.log(_.toArray(chatSnapshot.val()))

        _.each(_.toArray(chatSnapshot.val()), (item) => {
          console.log(item)
          if(item.timestamp > dateTimestamp){
            this.chatMessagesCount++
          }
        })*/

        trainingsSnapshot.forEach(trainingSnapshot => {

          if(trainingSnapshot.val().created > dateTimestamp){
            this.trainingCreatedCount++
          }
        })
        

      })
    })


    db.ref('teamMatches').on('value', (teamsSnapshot) =>{

      teamsSnapshot.forEach(matchesSnapshot => {
        /*console.log(_.toArray(chatSnapshot.val()))

        _.each(_.toArray(chatSnapshot.val()), (item) => {
          console.log(item)
          if(item.timestamp > dateTimestamp){
            this.chatMessagesCount++
          }
        })*/

        matchesSnapshot.forEach(matchSnapshot => {

          if(matchSnapshot.val().created > dateTimestamp){
            this.gamesCreatedCount++
          }
        })
        

      })
    })

    this.trainingAndGamesCreatedCount = this.gamesCreatedCount + this.trainingCreatedCount



    db.ref('userNotifications').on('value', (userSnapshots) =>{

      userSnapshots.forEach(notificationsSnapshot => {
        /*console.log(_.toArray(chatSnapshot.val()))

        _.each(_.toArray(chatSnapshot.val()), (item) => {
          console.log(item)
          if(item.timestamp > dateTimestamp){
            this.chatMessagesCount++
          }
        })*/

        notificationsSnapshot.child('notifications').forEach(notificationSnapshot => {

          if(notificationSnapshot.val().timestamp > pushDateTimestamp && notificationSnapshot.val().type == "chat"){
            this.chatPushCount++
          }

          if(notificationSnapshot.val().timestamp > dateTimestamp && notificationSnapshot.val().viewed == true){
            this.notificationsSeenCount++
          }

          if(notificationSnapshot.val().timestamp > dateTimestamp && notificationSnapshot.val().type == "access" && notificationSnapshot.val().action == "enabled"){
            this.playersWithAccess++
          }

          if(notificationSnapshot.val().timestamp > pushDateTimestamp && notificationSnapshot.val().action == "noAssist"){
            this.notificationsAbsenceCount++
          }
        })
        

      })
    })

  },
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
